module.exports = __webpack_public_path__ + "static/img/animales_02.7de02cc6.jpg";